import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollytellingHorizontal {
    constructor() {
        this.container = document.querySelector('.js-scrollytelling-horizontal');
    }

    init() {
        if (this.container) {
            this.run();
        }
    }

    run() {
        const subContainer = this.container.querySelector(".scroll-container");
        const endSection = document.querySelector('.js-scrollytelling-horizontal-end');
        gsap.registerPlugin(ScrollTrigger);

        const debug = false;

        gsap.to(this.container.querySelector('.icon-scroll'), {
            opacity: 1,
            delay: 2
        });

        let scrollContainer = gsap.to(subContainer, {
            xPercent: -100,
            x: () => window.innerWidth,
            ease: "none",
            scrollTrigger: {
                trigger: this.container,
                endTrigger: endSection,
                start: "top top",
                end: () => "+=" + subContainer.offsetWidth + "px",
                pin: this.container,
                scrub: 1,
                markers: debug
            }
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: subContainer,
                start: "left 0",
                end: "+=" + subContainer.offsetWidth + "px",
                scrub: 0.25,
                markers: debug
            },
        });

        const elements = this.container.querySelectorAll('.elements');

        tl
            .to(this.container.querySelector('.icon-scroll'), {
                opacity: 0
            })
            .to(elements[0], {
                translateX: "-" + window.innerWidth / subContainer.offsetWidth * 300 + 'px',
                ease: "power1.inOut"
            })
            .to(elements[1], {
                translateX: "-" + window.innerWidth / subContainer.offsetWidth * 300 + 'px',
                ease: "power1.inOut"
            }, "<");

        const tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: endSection,
                scrub: true,
                start: "top 90%",
                end: "bottom bottom",
                markers: debug
            }
        });

        tl2
            .from(endSection, {
                opacity: 0,
                translateY: "20%",
                duration: 3,
                ease: "power2.inOut",
            })
    }
}

export default new ScrollytellingHorizontal();
